import { useTranslation } from 'react-i18next';

export const removeRegionFromLocale = (locale: string | undefined) => {
  return locale?.split('-')[0] ?? 'en';
};

export const useTranslationLanguageWithoutRegion = () => {
  const { i18n } = useTranslation();

  const lang = removeRegionFromLocale(i18n.languages[0]);

  return {
    lang,
  };
};
